<!--
================================================
NewTaskComp

Url d'accès :
http://localhost:8080/fr/cronocloud-inc/timeTracking

Description : Permet de démarrer le tracking d'un nouveau task timerecord

    * Lorsqu'un task timerecord est continué depuis TaskTimerecordTableLineComp, le listener 'continue_task_event' démarre un task timerecord depuis ici.

================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="NewTaskComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}">
<!--        {{'Hello ! :) I am ' + $options.name}}-->

        <div  v-click-outside="onClickOutside"  class="columns">
            <div class="column">
<!--              <pre>{{tags}}</pre>-->

                <div class="appTitle">
<!--                    <font-awesome-icon :icon="['far', 'bookmark']" />-->
                    {{$t('CommencerUnPointage')}}
                </div>

                <div class="appBloc fieldBox" v-bind:class="{'is-loading':isSubmiting}">

                            <div class="columns is-mobile">

                                <div class="column is-8-mobile is-6-tablet is-6-desktop is-6-widescreen is-8-fullhd">
                                    <div class="field">
                                        <div class="control has-icons-left">
                                            <font-awesome-icon class="icon is-hidden-mobile  is-left leftIcons spinnerIcon" :icon="['fas', 'spinner']" spin  v-show="isSubmiting" />
                                           <font-awesome-icon class="icon  is-hidden-mobile is-left leftIcons" :icon="['far', 'bookmark']"  v-show="!isSubmiting" />

                                          <input class="input taskName" type="text"
                                                 v-bind:placeholder="$t('surQuoiTravaillezVous')"
                                                 v-on:keyup.enter="onEnter()"
                                                 v-on:keyup="debounceLoadSuggestions($event)"
                                                 v-model="taskName"
                                                 autocomplete="off"
                                                 v-validate="'max:255'" data-vv-validate-on="change"
                                                 name="newTask_taskName" id="newTask_taskName"
                                                 v-bind:class="{'is-loading':isSubmiting}"
                                          >
                                          <p class="help is-danger has-text-left" id="error_newTask_taskName">{{errors.first('newTask_taskName') }}</p>

                                        </div>
                                    </div>
                                </div>

                                <div class="column is-2-mobile is-4-tablet is-3-desktop is-3-widescreen is-2-fullhd blocMeta">

                                    <project-selector-comp v-bind:component-source="$options.name" v-bind:allow-create-invite="true"></project-selector-comp>
                                    <tag-selector-comp v-bind:component-source="$options.name" v-bind:allow-create-invite="true"></tag-selector-comp>

                                    <div class="columns is-mobile columnsMeta">
                                      <!--- PROJET -->
                                        <div class="column is-narrow project">
                                            <a tabindex="0"
                                               v-on:keyup.enter="toggleProjectSelectorVisibility()"
                                               v-on:click="$root.$emit('hide_suggested_timerecords'),toggleProjectSelectorVisibility()"
                                               id="projectSelectorSwitch" class="switchProjectSelector_js">

                                                <font-awesome-icon v-if="project!== null" v-bind:style="{color:'#'+ project.color}" class="icon switchProjectSelector_js" :icon="['far', 'folder-open']"/>
                                                <font-awesome-icon v-else class="icon switchProjectSelector_js" :icon="['far', 'folder-open']"/>

                                                <span v-if="project!== null" class="projectName switchProjectSelector_js" >{{project.name}}</span>
                                                <span v-else v-bind:title="$t('choisirUnProjet')"  class="nomChamp is-capitalized is-hidden-mobile switchProjectSelector_js" >{{$t('projet')}}</span>

                                            </a>
                                        </div>

                                        <!--TAG-->
                                        <div class="column is-narrow mx-2 tagZone" >
                                          <a tabindex="0"
                                             v-on:keyup.enter="toggleTagSelectorVisibility()"
                                             v-on:click="$root.$emit('hide_suggested_timerecords'), toggleTagSelectorVisibility()"
                                             id="tagSelectorSwitch" class="has-text-grey-light is-block mr-2 switchTagSelector_js">

                                            <font-awesome-icon  class="icon switchTagSelector_js" :icon="['fas', 'tag']"/>

                                            <!-- si un tag au moins est sélectionné affichage du nombre de tags sélectionnés -->
                                            <span v-if="tags.length> 0" class="has-text-grey-light tagName nomChamp  switchTagSelector_js" v-bind:title="$tc('xTags',tags.length)">
                                              {{$tc('xTags',tags.length)}}
                                            </span>
                                            <span v-else v-bind:title="$t('choisirDesTags')"  class="nomChamp is-capitalized is-hidden-mobile switchTagSelector_js" >{{$t('Tags')}}</span>

                                          </a>
                                        </div>

                                        <div class="column is-narrow is-pulled-right">
                                            <billable-selector></billable-selector>
                                        </div>
                                    </div>

                                </div>

                                <div class="column is-2-mobile is-2-tablet is-3-desktop is-3-widescreen is-2-fullhd ">
                                    <a class="button is-fullwidth startTaskBtn is-hidden-touch"
                                       v-on:click="validateBeforeSubmit"
                                       v-bind:class="{'is-loading':isSubmiting}"
                                       v-on:keyup.enter="validateBeforeSubmit()"
                                       id="newTask_submit"

                                    >
                                        <span class="icon" v-show="!isSubmiting">
                                            <font-awesome-icon class="icon" :icon="['fas', 'play-circle']" />
                                        </span>
                                        <span tabindex="0" class="is-hidden-touch">{{$t('commencer')}}</span>
                                    </a>

                                    <a class="button is-fullwidth startTaskBtn mobileBtn is-hidden-desktop"
                                       v-on:click="validateBeforeSubmit"
                                       v-bind:class="{'is-loading':isSubmiting}"
                                       >
                                        <font-awesome-icon class="icon" :icon="['fas', 'play-circle']" />

                                    </a>
                                </div>

                            </div>


                  <!-- affichage de 2 tips pour inviter à faire u 1er tr si pas de timerecord -->
                <div v-if="showIntroTips" class="contIntroTips">
                  <div class="introTips" id="tip1" v-html="$t('introTips1',{firstname:user.firstname})" >
                  </div>
                  <div class="introTips" id="tip2" v-html="$t('introTips2')" >
                  </div>
                </div>

                <suggested-timerecords-comp></suggested-timerecords-comp>

                </div>

            </div>
        </div>

    </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SentryMixin from "../mixins/SentryMixin.js";
    import ProjectSelectorComp from "./ProjectSelectorComp";

    // import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import BillableSelector from "./BillableSelectorComp.vue";
    import _ from "lodash";
    import SuggestedTimerecordsComp from "@/components/SuggestedTimerecordsComp";
    import vClickOutside from 'v-click-outside'
    import TimeTrackingView from "@/views/TimeTrackingView";
    import TagSelectorComp from "@/components/Tags/TagSelectorComp";
    import TagComp from "@/components/Tags/TagComp";
    import TrackingMixin from "@/mixins/TrackingMixin";

    export default {
        name: 'NewTaskComp', //utile dans vue dev tool
        mixins: [GlobalErrorNotification, SentryMixin, InterceptorMixin, TrackingMixin],
        components: {TagComp, TagSelectorComp, SuggestedTimerecordsComp, ProjectSelectorComp,BillableSelector},

      directives: {
        clickOutside: vClickOutside.directive,
      },


      data: function () {
            return {
                locale : this.$route.params.locale,
                // pour les composants où l'user est identifié ///////////////////////
                organizationSlug: this.$route.params.organization,
                userSlug: JSON.parse(this.$cookie.get('auth')).userSlug,
                // =================================================================
                isSubmiting: false ,     // indique si le formulaire est en cours de soumission
                taskName: null, // String le nom de la tâche
                project: null, // Object  L'objet projet à rattacher au timerecord
                tags: [], // Array | Un array d'objets tags à rattacher au timerecord
                isBillable: false, // Bool indique si la task est facturable
                taskTrToContinue: null, // Objet Timerecord, un timerecord à continuer
                showIntroTips: false,  // bool indique si l'on doit afficher .contIntroTips

            }
        },

        computed:{
                // computed props for store :
            ...mapState({
                user: state => state.user,
                timerecords: state => state.TaskTimerecordListComp.timerecords,
                themeToDisplay: state =>state.app.themeToDisplay,
                suggestedTimerecords: state => state.TimeTrackingView.suggestedTr.timerecords,
                trCurrentActiveSuggestion: state =>state.TimeTrackingView.suggestedTr.indexCurrentActive,

            }),

          /**
           * Un array contenant les slugs des tags sélectionnés (à l'inverse de this.tags, ne contien QUE les slugs)
           * Pour envoi dans la requête dans startTaskQuery()
           *
           * //@todo deprecated ? à présent this.tags contient des slug s?
           */
          // tagsSlug: {
          //     get: function(){
          //       let slugs = []
          //       if (this.tags.length > 0) {
          //         this.tags.forEach(function (tag) {
          //           slugs.push(tag.slug)
          //         })
          //         return slugs
          //       }
          //       else{
          //         return this.tags
          //       }
          //     }
          // }


        },
        watch: {
          taskName: function (){
            if (_.isEmpty(this.taskName)){
              // si taskName est vidé on masque emet un event qui permettra de masque SuggestedTimerecordsComp
              this.$root.$emit('new_task_comp_taskName_empty')
            }
          }
        },


        methods: {

          /*
          Permet de controller le comportement de la touche entrer, elle envoie le formulaire sauf si une suggestion est active dans SuggestedTimerecordsComp
          */
          onEnter: function (){
            if ( // on envoie les suggestions à la place du formulaire si :
                this.suggestedTimerecords.length > 0 && // si il y a au moins 1 suggestion ET...
                this.trCurrentActiveSuggestion != -1 || ! _.isEmpty(this.trCurrentActiveSuggestion)  // si une suggestion est active dans SuggestedTimerecordsComp
                // (NOTE: à -1 il y a des suggestions mais aucune n'est active, cela permet de commencer une tâche "testing new" si une suggestion "testing new software" existe)
              ){
              this.$root.$emit('copy_current_suggested_tr_to_new_task')
            }
            else{ // sinon on envoie le formulaire
              this.validateBeforeSubmit()
            }

          },

            /*
            * Valide le formulaire avant sa soumission
            */
            validateBeforeSubmit() {
                this.isSubmiting = true;

                let self = this
                this.$validator.validateAll().then((result) => {
                    if (result) { // si la validation. réussie
                        self.startTaskQuery();
                    } else { // si il y a des erreurs...
                        self.isSubmiting = false;
                    }

                })
            },

            /*
            Envoi la requête de soumission du formulaire
            */
            startTaskQuery() {

                let self = this
                // console.log("👉 envoi des tags : "+this.tags)

                // définition des params d'url obligatoires & facultatifs
                const params = {
                    isTask: true,
                    taskName: self.taskName,
                    timezone: self.user.timezone,
                    isBillable: self.isBillable,
                    workspace: self.$auth.getActiveWorkspace(),

            }
                if (this.project) { params.project = self.project.slug }
                // if (this.tags) { params.tags = self.tagsSlug } // ne fonctionne pas créé une erreur 403 lors de la création d'un tr avec tag @todo supr ?
                if (this.tags) { params.tags = self.tags }

                return self.$http
                    .post(`organizations/${self.organizationSlug}/users/${self.userSlug}/taskin`, params,
                        {headers: {Authorization: self.$auth.header()}}
                    )
                    .then(function (response) {

                        if (response.status == 201) {
                            self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                            // on enregistre le TaskTimerecord que l'on vient de créer dans le store
                            self.$store.commit('UpdateTimeTrackingViewCurrentTask', response.data);

                            //on met à jour les timerecords dans le UpdateTaskTimerecordListComp
                            self.timerecords.unshift(response.data)
                            self.$store.commit('UpdateTaskTimerecordListComp', {
                                'timerecords' : self.timerecords
                            });

                          self.$root.$emit('new_task_started')

                          self.ga4GlobalEventTrack('New task started' , {})


                          self.$mixpanel.track("New task started");
                        }
                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
                            let errorCode = '0043'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error creating task', 'fatal': false})
                            self.$mixpanel.track('global error displayed', {
                                "id": errorCode,
                                "detail": "error creating task timerecord "
                            })
                            self.$sentry.captureMessage(`Error ${errorCode} > error creating task timerecord : ${error}`, 'error')

                        }
                    }).then(() => {
                        // toujours exécuté
                        self.isSubmiting = false;
                    })

            },

            /**
             * Toggle la visbilité du composant projectSelectorComp
             */
            toggleProjectSelectorVisibility() {
                this.$root.$emit('toggle_project_selector_visibility', this.$options.name)
            },


          /**
           * Toggle la visbilité du composant tagSelectorComp
           */
          toggleTagSelectorVisibility() {
            this.$root.$emit('toggle_tag_selector_visibility', this.$options.name)
          },

          /**
           * Déclenche this.continueTaskTr() avec debounce de 400ms (pour corriger bug #242 : tr continué en double).
           */
          debounceContinueTask:
              _.debounce(
                  function () {
                    this.continueTaskTr()
                  }, 400),

          /**
           * Déclenche la continuation d'un task tr
           */
          continueTaskTr(){
            this.taskName= this.taskTrToContinue.taskName
            this.project= this.taskTrToContinue.project
            this.isBillable = this.taskTrToContinue.isBillable
            this.tags = this.taskTrToContinue.tags

            // on créé un tableau cotenant uniquement les slugs des tags
            let tagsSlugs= []
            this.tags.forEach(function (tag,index){
              tagsSlugs.push(tag.slug)
            })
            this.tags = tagsSlugs

            this.startTaskQuery()
          },


          /*
           Emet un event pour signaler SuggestedTimerecordsComp de charger les sugestions
           */
          debounceLoadSuggestions:
                  function (event) {
                    // https://css-tricks.com/snippets/javascript/javascript-keycodes/
                    if(event.key == "ArrowUp"  ) {
                      this.$root.$emit('timerecords_suggestions_scroll','up')
                    }
                    if(event.key == "@"  ) { //@todo pour feat https://gitlab.com/ousmane1/kronocloud/-/issues/488
                    }
                    else if(event.key == "ArrowDown"){
                      this.$root.$emit('timerecords_suggestions_scroll','down')
                    }
                    else if(event.key == "Escape"){ // masquage avec Escape
                      this.$root.$emit('hide_suggested_timerecords')
                    }
                     else if (
                        // on le chargement des suggestion uniquement si le taskName n'est pas vide, et si certaines touches ne sont pas préssées

                          event.key != "Enter" &&
                          event.key != "Alt" &&
                          event.key != "ArrowUp" &&
                          event.key != "ArrowDown" &&
                          event.key != "Shift" &&
                          event.key != "ArrowLeft" && // left arrow
                          event.key != "ArrowRight" && // right arrow
                          !_.isEmpty(this.taskName)) {

                        this.$root.$emit('timerecord_suggestions_required', this.taskName)

                      }
                  },


          /**
           * Copie le timerecord passé en paramètre dans les valeurs du nouveau timerecord à commencer
           *
           * @param object timerecord | le timerecord suggéré à copié
           */
          copySuggestedTimerecord(timerecord){
            this.taskName =timerecord.taskName

            if(!_.isEmpty(timerecord.project)){
              this.project=timerecord.project
            }
            this.isBillable = timerecord.isBillable
            this.validateBeforeSubmit()

          },

          onClickOutside (event) {
              this.$root.$emit('new_task_comp_click_outside')
          }

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {

            // Dans listener du continue_task_event on copie le taskname puis on déclenche la création du task tr (la maj du store sera effectuée dans startTaskQuery)
            this.$root.$once('continue_task_event', (timerecord) => {
              this.taskTrToContinue = timerecord
                this.debounceContinueTask()
                this.$vueScrollTo.scrollTo('#NewTaskComp')
            })

            // Listener écoutant la sélection d'un projet dans ProjectSelectorComp
            this.$root.$on('project_selected', (project, source) => {
              if(source == this.$options.name) { // on vérifie que le projet à bien été sélectionné dans le ProjectSelectorComp du composant actuel
                this.project = project
              }
            })

          // Listener écoutant la sélection des tags dans TagSelectorComp
          this.$root.$on('tags_selected', (tags, source) => {
            if(source == this.$options.name) { // on vérifie que le tag à bien été sélectionné dans le TagSelectorComp du composant actuel
              this.tags = tags
            }
          })

            // Listener écoutant les updates du BillableSelector
            this.$root.$on('billable_selector_updated', (isBillable) => {
                this.isBillable= isBillable
            })

          // Listener écoutant copy_suggested_timerecord
          this.$root.$on('copy_suggested_timerecord', (timerecord) => {
            this.copySuggestedTimerecord(timerecord)

            let trackingDetail = "Timerecord created from suggestion"
            this.$mixpanel.track(trackingDetail, {})
            this.ga4GlobalEventTrack(trackingDetail , {})

          })

          // si l'evenement no_task_timerecord_2_load_event a été déclenché affichage des intro tips
          this.$root.$on('no_task_timerecord_2_load_event', () => {
            this.showIntroTips = true
          })

        },
      beforeDestroy () {
        /**
         * On supprime le listener sur "copy_suggested_timerecord"
         * Évite que l'event "copy_suggested_timerecord" soit déclenché plusieurs fois (solution inspirée de https://stackoverflow.com/a/61049328/666416 et https://charlietheprogrammer.com/duplicate-vue-event-listeners-and-how-i-solved-them)
         **/
        this.$root.$off('copy_suggested_timerecord')

      },
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style lang="scss">
/* ⚠️ css non scoppé*/
@import "../assets/css/globalVar.scss";

.attentionDot {
  display: inline-block;
  margin: 0 .6rem 0 .3rem;
  height: .6rem;
  width: .6rem;
  background: $brandOrange;
  border-radius: 1rem;

  animation: glow 0.5s infinite alternate;

@keyframes glow {
  from {
    //background: rgb(243, 188, 23);
    transform: scale(.9);
    box-shadow:  0 0 1px #666;
    border: solid 1px white;
  }
  to {
    //background: gold;
    transform: scale(1.7);
    //box-shadow:  0 0 .7rem gold;
    background: transparent;
    border: solid 1px white;


  }
}

}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    @import "../assets/css/bulmaResponsiveDep.scss";

    #NewTaskComp{

      /////////////////////////////////////////
      // LIGHT THEME ///////////////////////////
      position: relative;

      $height:3.8rem;

      .contIntroTips{
        display: flex;
        position: relative;
        margin-top: -2.9rem;
        justify-content: space-between;

        .introTips {
          font-weight: bold;
          color: white;
          background: rgba(6,10,12,0.5);
          box-shadow: 0 0 .4rem #ddd;
          border-radius: .1rem;
          font-size: .9rem;
          padding: .6rem;
        }

        .introTips#tip1{
          justify-self: flex-start;
        }
        .introTips#tip2{
          justify-self: flex-end;
        }
      }

      .fieldBox{
        height: $height;

        border-radius: 3px;
        background: white;
        border-style: solid;
        border-width: 1px;
        border-color: rgb(153, 204, 51);
        box-shadow: 0 0 7px 0 rgba(153, 204, 51, 0.35);

        .leftIcons{
          color: #ccc ;
          margin :  1.3rem 0 0 0.8rem ;
          height: 1.2rem ;
        }

        .spinnerIcon {
        }

        .taskName {
          background: transparent !important;
          font-size: 1.1rem;
          color: $brandThird;
          height: 3.6rem ;
          padding: 0 1.5rem 0 3.5rem;
          font-weight: bold;
          border: none ;
          outline: none ;
          box-shadow: none ;


          @include mobile {
            font-size: 1rem;
            padding-left: .8rem;
          }

          &::placeholder{

            font-weight: normal;
            font-style: italic;
            color: $brandFourth;
          }
          &.is-loading{
            /*when submitting*/
            opacity: 0.7;
          }

        }

        .blocMeta{
          height: $height;
          margin-top: 0.9rem;
          .icon{padding-top: 0.3rem;}
          .column{
            font-weight: bold;
            cursor: pointer;
            padding-right: 0;
            padding-left: 0;

            .icon{
              margin-right: 0.3rem;
              margin-left: 0.5rem;
            }
            .nomChamp{
              border-right: solid 1px #eee;
              padding-right: 1rem;
              //&:last-child{ border: none !important;}
            }
            &:hover{
            }
          }

          .project{
            margin-left: 1rem;
            //margin-right: 0.5rem;
            color: $projectColor;

            &:hover {
              color: lighten($projectColor, 8%);
            }

            .projectName{
              color:#666;
              &:hover {
                color: lighten(#666, 8%);
              }
            }
          }

          .columnsMeta{
            justify-content: flex-end; // aligne les .column à droite
            .project a {
            }
            .tagZone a{
              //color: $brandFourth !important;

              &:hover {
                color: lighten($brandFourth, 8%);
              }
              .icon{color:#ddd !important;}

              .tagName{
                color:#666;
                &:hover {
                  color: lighten(#666, 8%);
                }
              }
            }



          }
        }

        // le message d'erreur
        .help.is-danger {
          margin: 1rem 0;
          color:$brandRed;
        }
      }

      .startTaskBtn {
        height: 3.7rem;
        background: $brandPrimary;
        color: white;
        border-radius: 0 3px 3px 0;
        font-weight: bold;
        font-size: 1.1rem;
        border: none;

        border-left: solid 1px #ddd;

        &:hover {
          background: darken($brandPrimary, 2%);
          transition: background 200ms;
          border: none;
          border-left: solid 1px #ddd;
          text-shadow: 0 2px darken($brandPrimary, 5%);
        }

        &:active {
          background: darken($brandPrimary, 5%);

          box-shadow: 0 0 5px darken($brandPrimary, 13%) inset;
          border: none;
          border-left: solid 1px #ddd;

          .icon {
            /*color: white;*/
          }
        }

        .icon {

          color: white;
          height: 1.4rem;

        }

        &.mobileBtn {
          /*background: #000;*/
          height: 3.69rem;


        }
      }

      /////////////////////////////////////////
      // DARK THEME ///////////////////////////
      &.darkMode {

        .contIntroTips{

          .introTips {
            background-color: rgba(33,135,198,.7);
            box-shadow: none;
          }

        }

        .fieldBox{
          background: $darkBg4 !important;
          border-color: desaturate($brandPrimary,10%);
          box-shadow:none;

          .leftIcons{color: #758082}
          .taskName{
            color: $darkTxt;
            //&::placeholder{color: $brandFourth;            }
          }

          .blocMeta{
            .project{
              a{
                color:$darkLightBlue;
                &:hover {
                  color: lighten($darkLightBlue, 8%);
                }
              }


            }
            .nomChamp{border-color: #666}
          }
        }

        .startTaskBtn{
          color: $darkTxtOnPrimary;
          border-left: solid 1px $darkFieldBg;

          &:hover {
            background: darken($brandPrimary, 2%)
          }
          &:active {
            background: darken($brandPrimary, 5%)
          }
          .icon{
            color: $darkTxtOnPrimary;
          }
        }

        .blocMeta {
          .columnsMeta {
            .tagZone a {
              color: darken($darkTxt,30%) !important;

              &:hover {
                color: darken($darkTxt,10%) !important;
                .icon {
                  color: darken($darkTxt,10%) !important;
                }
              }

              .icon {
                color: darken($darkTxt,30%) !important;
              }

              .tagName {
                color: darken($darkTxt,30%) !important;

                &:hover {
                  color: darken($darkTxt,20%) !important;
                }
              }
            }


          }
        }

      }
    }


</style>
